/**
 * Shared map coordinate + display-mode helpers.
 * Used by Tour Planner food-hub pins and persisted pin/hide prefs.
 */

export function hasValidMapCoords(value) {
  if (!value) return false;
  const lat = Number(value.latitude ?? value.lat);
  const lng = Number(value.longitude ?? value.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return false;
  if (lat === 0 && lng === 0) return false;
  return true;
}

/** Clusters were retired from the UI; coerce saved prefs so users are not stuck. */
export function coerceMapDisplayMode(mode) {
  if (mode === 'clusters') return 'pins';
  if (mode === 'pins' || mode === 'hidden') return mode;
  return null;
}

export const PENDING_CREDIT_STATUSES = ['pending', 'in_review'];

export function isPendingCreditStatus(status) {
  return PENDING_CREDIT_STATUSES.includes(String(status || '').toLowerCase());
}

/** Dedupe document ids across per-field snapshot buckets, then price them. */
export function summarizePendingCredits(byKey, earnCents) {
  const seen = new Set();
  Object.values(byKey || {}).forEach((ids) => {
    (ids || []).forEach((id) => seen.add(id));
  });
  const pendingCount = seen.size;
  const unit = Number(earnCents) || 0;
  return { pendingCount, pendingCents: pendingCount * unit };
}
